import styled from 'styled-components';

import { Flex, Tag, Typography } from '../../../designComponents';
import PDFPlaceholder from '../../../designComponents/PDFPlaceholder';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { humanReadableDateWithTime } from '../../../utils';

const UploadedPDFViewStyled = styled.div`
  width: 100%;
  max-width: 1000px;
  position: relative;
  padding-top: 30px;

  & .status-container {
    position: absolute;
    top: 0px;
    right: 0px;

    z-index: 10;
  }
`;

type Props = {
  review: {
    _id: string;
    isActive: boolean;
    pdf: {
      title: string;
      url: string;
      _id: string;
    }[];
    pdfNotes?: string[];
    reviewStatus?: string;
    reviewSendDate: string;
    reviewBy: string;
    reviewDate: string;
    reviews: string[];
  };
};

const UploadedPDFView = ({ review }: Props) => {
  const status = review.reviewStatus;
  return (
    <UploadedPDFViewStyled>
      <Flex justifyContent="flex-end" className="status-container">
        <Tag
          type={
            status === 'PENDING'
              ? 'warning'
              : status === 'ACCEPT'
                ? 'success'
                : status === 'REJECT'
                  ? 'danger'
                  : 'caution'
          }
        >
          {review.reviewStatus}
        </Tag>
      </Flex>
      {review.pdf.map((latestPDF) => {
        return (
          <>
            <Flex
              key={latestPDF._id}
              gap="20px"
              direction="row"
              justifyContent="space-between"
              margin="0px 0px 20px"
            >
              <Typography
                variant="title"
                style={{ fontWeight: 500, maxWidth: '600px' }}
              >
                {latestPDF.title}
              </Typography>
              <PDFPlaceholder link={latestPDF.url} />
            </Flex>
          </>
        );
      })}
      {review.reviewSendDate && (
        <>
          <Typography
            variant="title"
            style={{ marginBottom: '6px', fontWeight: 500 }}
          >
            Sent For Review Date :
          </Typography>
          <Typography style={{ marginBottom: '20px', fontWeight: 400 }}>
            {humanReadableDateWithTime(review.reviewSendDate)}
          </Typography>
        </>
      )}
      <Typography
        variant="title"
        style={{ marginBottom: '12px', fontWeight: 500 }}
      >
        Notes :
      </Typography>
      {review.pdfNotes?.map((latestNotes, index) => (
        <Typography key={index} style={{ marginBottom: '8px' }}>
          {latestNotes}
        </Typography>
      ))}
      {review?.reviewDate && (
        <>
          <Typography
            strong
            fontColor="secondary"
            style={{ marginTop: '50px' }}
          >
            PDF REVIEW BY ESCAPE PLAN
          </Typography>
          <VerticalSpaceStyled $space={10}>
            <InfoRowStyled>
              <Typography className="title">Review Date :</Typography>
              <Typography className="value">
                {humanReadableDateWithTime(review?.reviewDate)}
              </Typography>
            </InfoRowStyled>
            <InfoRowStyled $direction="column">
              <Typography className="title">
                Notes from Escape Plan :
              </Typography>
              <div className="value">
                <div>
                  {review?.reviews?.map((reviews) => (
                    <Typography
                      key={reviews.substring(0, 50)}
                      style={{ marginBottom: '8px' }}
                    >
                      {reviews}
                    </Typography>
                  ))}
                </div>
              </div>
            </InfoRowStyled>
          </VerticalSpaceStyled>
        </>
      )}
    </UploadedPDFViewStyled>
  );
};

export default UploadedPDFView;
